<div class="form-group">

  <div class="form-check">
    <input
      type="checkbox"
      class="form-check-input"
      id="bRecuperarProcesoPrevio"
      [(ngModel)]="bRecuperarProcesoPrevio"
    />
    <label class="form-check-label" for="bRecuperarProcesoPrevio">
      Recuperar Proceso Previo
    </label>
  </div>

  <div class="form-check">
    <input
      type="checkbox"
      class="form-check-input"
      id="bAlmacenarEnLaBase"
      [(ngModel)]="bAlmacenarEnLaBase"
    />
    <label class="form-check-label" for="bAlmacenarEnLaBase">
      Almacenar en la base
    </label>
  </div>

  <label *ngIf="bRecuperarProcesoPrevio" for="juego">Inicio de Ejecuciones</label>
  <input *ngIf="bRecuperarProcesoPrevio" type="number" [(ngModel)]="inicioEjecuciones" min="1" class="form-control" placeholder="Número de ejecuciones">
  <label *ngIf="bRecuperarProcesoPrevio" for="juego">Identificador Ultima Prediccion</label>
    <input 
      *ngIf="bRecuperarProcesoPrevio" 
      type="text" 
      [ngModel]="ultimaPrediccion?.identificador || ''" 
      (ngModelChange)="ultimaPrediccion.identificador = $event"
      class="form-control" 
      placeholder="Resultado del Juego">

  <label for="juego">Cantidad de Ejecuciones</label>
  <input type="number" [(ngModel)]="cantidadEjecuciones" min="1" class="form-control" placeholder="Número de ejecuciones">
  <label for="juego">Fecha Seleccionada</label>
  <input type="date" [(ngModel)]="fechaSeleccionada" class="form-control" placeholder="Selecciona una fecha">
  <div class="form-group">
    <label for="juego">Selecciona un juego</label>
    <select id="juego" [(ngModel)]="juegoSeleccionado" class="form-control">
      <option value="MELATE">MELATE</option>
      <option value="REVANCHA">REVANCHA</option>
      <option value="REVANCHITA">REVANCHITA</option>
      <option value="MELATE_RETRO">MELATE RETRO</option>
    </select>
  </div>
  <label for="metodo">Método de predicción</label>
  <select id="metodo"
          [(ngModel)]="metodoSeleccionado"
          (ngModelChange)="onMetodoChange($event)"
          class="form-control">
    <option *ngFor="let m of metodos" [ngValue]="m">{{m.label}}</option>
  </select>
</div>

<label for="juego">Resultado del Juego</label>
<input type="text" [(ngModel)]="resultadoJuego" min="1" class="form-control" placeholder="Resultado del Juego">

<!-- Botón -->
<a class="btn btn-primary mb-2 btn-sm-block" 
   style="margin: 10px 10px 10px 10px;" 
   (click)="obtenerMordredPrediccionUnionPost()" 
   rippleEffect>
   Obtener Predicción para {{juegoSeleccionado}} en {{metodoSeleccionado.value}} (x{{cantidadEjecuciones}}) al {{fechaSeleccionada}}
</a>


<a class="btn btn-primary mb-2 btn-sm-block" 
   style="margin: 10px 10px 10px 10px;" 
   (click)="obtenerPatronPredicciones()" 
   rippleEffect>
   Obtener Patrón de Predicciones para {{juegoSeleccionado}} en {{metodoSeleccionado.metodoPrediccion}} del {{fechaSeleccionada}}
</a>

<a class="btn btn-primary mb-2 btn-sm-block" 
   style="margin: 10px 10px 10px 10px;" 
   (click)="consultarUltimaPrediccion()" 
    *ngIf="bRecuperarProcesoPrevio" 
   rippleEffect>
   Consultar Ultima Prediccion para {{juegoSeleccionado}} en {{metodoSeleccionado.metodoPrediccion}} del {{fechaSeleccionada}}
</a>

    <!-- ngb-alert component -->
    <ngb-alert  *ngIf="alertDanger" [type]="'danger'" [dismissible]="false">
      <h4 class="alert-heading">Error</h4>
      <div class="alert-body">
        {{ mensajeDanger }}
      </div>
    </ngb-alert>
    <!--/ ngb-alert component -->

      <!-- ngb-alert component -->
      <ngb-alert  *ngIf="alertSuccess" [type]="'success'" [dismissible]="false">
        <h4 class="alert-heading">Success</h4>
        <div class="alert-body">
          {{ mensajeSuccess }}
        </div>
      </ngb-alert>
      <!--/ ngb-alert component -->
<h5>Predicción:</h5>
<pre class="pretty-json">{{ resultadoPrediccion | json }}</pre>


<!-- Botón -->
<a class="btn btn-primary mb-2 btn-sm-block" 
   style="margin: 10px 10px 10px 10px;" 
   (click)="consultarEfectividad()" 
   rippleEffect>
   Consultar Efectividad para {{juegoSeleccionado}} del {{fechaSeleccionada}} Resultado {{resultadoJuego}}
</a>

<hr>

<table class="table table-striped table-bordered mt-2" *ngIf="prediccionesEvaluadas.length > 0">
  <thead>
    <tr>
      <th>Id</th>
      <th>Numero</th>
      <th>Total</th>
      <th>Identificador</th>
      <th>Fecha Concurso</th>
      <th>Predicción</th>
      <th>Juego</th>
      <th>Método</th>
      <th>Coincidencias</th>
      <th>Números Coincidentes</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let r of prediccionesEvaluadas">
      <td>{{ r.id }}</td>
      <td>{{ r.numero }}</td>
      <td>{{ r.total }}</td>
      <td>{{ r.identificador }}</td>
      <td>{{ r.fechaConcurso | date:'yyyy-MM-dd' }}</td>
      <td>{{ r.prediccion }}</td>
      <td>{{ r.juego }}</td>
      <td>{{ r.metodoPrediccion }}</td>
      <td>{{ r.coincidencias }}</td>
      <td>{{ r.numerosCoincidentes }}</td>
    </tr>
  </tbody>
</table>


<a class="btn btn-primary mb-2 btn-sm-block" 
   style="margin: 10px 10px 10px 10px;" 
   (click)="detenerPredicciones()" 
   *ngIf="bEjecutandoPredicciones" 
   rippleEffect>
   Detener proceso de predicciones
</a>